import { createApp } from 'vue'
import App from './App.vue'
import AppPhone from '../src/phone/phoneApp.vue'

import ElementPlus from 'element-plus'
import store from './store'
import router from './router'
import Directives from '@/components/click';
import 'element-plus/dist/index.css'
import "./css/flex.less"
import "./css/color.less"
import "./css/margin.less"
import "./css/padding.less"
import "./css/font.less"
import "./css/line-height.less"


import "lib-flexible-computer";
if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    // 当前设备是移动设备
    const app = createApp(AppPhone)
    app.use(store)
    app.use(router)
    app.use(Directives)
    app.use(ElementPlus).mount('#app')
} else {
    const app = createApp(App)
    app.use(store)
    app.use(router)
    app.use(ElementPlus).mount('#app')
}


